import gql from 'graphql-tag';


export const ALLREGIONAL = gql`
  query todosRegional{
    regionales{
      id
      nombre
    }
  }
`;


export const REGIONAL = gql`
  query getRegional($id:String!){
    regional(id:$id){
      id
      nombre
    }
  }
`;


